import UnauthorizedPage from 'components/UnauthorizedPage'
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'

import ReportsPage from './components/ReportsPage'

function Reports() {
  const { canViewSubmissionReport } = usePermissions()

  if (!canViewSubmissionReport) {
    return <UnauthorizedPage />
  }

  return <ReportsPage />
}

export default Reports
